import Layout from '../../layout'
import { Vouchers } from './vouchers'

export const VouchersPage = () => {
  return (
    <Layout>
      <Vouchers />
    </Layout>
  )
}
